





















import { computed, defineComponent } from '@vue/composition-api';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import LoaderState from '@front-app/components/LoaderState.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import ScrollingColumn from '@front-app/components/layouts/columns/ScrollingColumn.vue';
import { useAdminAccess } from '@front-app/modules/group/hooks/useAdminAccess';
import { GroupsStore } from '@front-app/store/singletons/Groups';

export default defineComponent({
	components: {
		ErrorCard,
		LoaderState,
		PaddedContent,
		ScrollingColumn,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));
		const hasGroupLoaded = computed(() => GroupsStore.getInstance().isGroupLoaded(props.groupId));
		const { hasAdminPageAccess } = useAdminAccess(group);

		return {
			hasGroupLoaded,
			hasAdminPageAccess,
		};
	},
});
